"use client";

import { useEffect } from "react";

/**
 * Dev-only: слушает SSE-поток /styles-events и при изменении CSS-файла
 * перетягивает соответствующий <link> заново (бамп query-параметра).
 * Стиль применяется на лету, без перезагрузки страницы — состояние не теряется.
 */
export default function CssAutoReload() {
  useEffect(() => {
    const source = new EventSource("/styles-events");

    source.onmessage = (e) => {
      const data = e.data;
      if (!data || data === "connected" || data === "ping") return;

      const pathname = `/styles/${data}`;
      document
        .querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')
        .forEach((link) => {
          const url = new URL(link.href);
          if (url.pathname === pathname) {
            url.searchParams.set("t", Date.now().toString());
            link.href = url.toString();
          }
        });
    };

    return () => source.close();
  }, []);

  return null;
}
